module.exports = __webpack_public_path__ + "static/media/logo-buffer.c60ed6c2.svg";